import CalamitiesLogDataTable from "../../../components/dataTable/tables/calamities/CalamitiesLogDataTable";

function CalamitiesLogPageView() {
    return <CalamitiesLogDataTable />;
}

export default CalamitiesLogPageView;